import './checkbox.scss';

interface CheckboxProps {
    onClick: () => void
    checked: boolean
    id: string
    label: string
    disabled: boolean
}

export const Checkbox = ({ onClick, checked, id, label, disabled }: Readonly<CheckboxProps>) => {

    return (
        <div className="checkbox" data-testid={`checkbox-${id}`}>
            <label htmlFor={id} className="checkbox__label" data-testid={`checkbox-label-${id}`}>
                <input
                    disabled={disabled}
                    type="checkbox"
                    onClick={onClick}
                    defaultChecked={checked}
                    id={id}
                    className='checkbox__input'
                    autoComplete='off'
                    data-testid={`checkbox-input-${id}`}
                />
                {label}
            </label>
        </div>
    );
};
